module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/3@2x_ada73d940de3b0d34f01fe87cc31dd48.png";